export default window.siteLanguage;